export const careI18n = {
  care: {
    en: {
      CLIENT_NAME: 'Client name',
      CLIENT_RECORDS: 'Client records',
      CONTINUE: 'Continue',
      DOCUMENT_TYPE: 'Document type',
      DOCUMENTS: 'Documents',
      DUE_DATE: 'Due date',
      END_DATE: 'End date',
      FOSTER_FAMILY_RECORDS: 'Foster family records',
      OBFUSCATE: 'Obfuscate',
      OBFUSCATE_CLIENT: 'Obfuscate client',
      OBFUSCATE_CLIENT_CONFIRMATION:
        'Are you sure you want to obfuscate client? This action cannot be undone and will anonymize all information that can be used to identify the client.',
      RECORD_COULD_NOT_BE_UPDATED: 'Record could not be updated',
      RECORD_UPDATED_SUCCESSFULLY: 'Record updated successfully',
      START_DATE: 'Start date',
      VERIFIED: 'Verified',
    },
    'sv-SE': {
      CLIENT_NAME: 'Klientnamn',
      CLIENT_RECORDS: 'Klientdokument',
      CONTINUE: 'Fortsätt',
      DOCUMENT_TYPE: 'Dokumenttyp',
      DOCUMENTS: 'Dokument',
      DUE_DATE: 'Förfallodatum',
      END_DATE: 'Slutdatum',
      FOSTER_FAMILY_RECORDS: 'Familjehemsdokument',
      OBFUSCATE: 'Gallra',
      OBFUSCATE_CLIENT: 'Gallra klient',
      OBFUSCATE_CLIENT_CONFIRMATION:
        'Är du säker på att du vill gallra klienten? Denna åtgärd kan inte ångras och kommer att anonymisera all information som kan användas för att identifiera klienten.',
      RECORD_COULD_NOT_BE_UPDATED: 'Dokumentet kunde inte uppdateras',
      RECORD_UPDATED_SUCCESSFULLY: 'Dokumentet uppdaterades',
      START_DATE: 'Startdatum',
      VERIFIED: 'Verifierad',
    },
  },
};
